export default {
  cost_per_static: "apps",
  cost_per_video: "play_circle_filled",
  cost_per_reel: "movie",
  cost_per_story: "slow_motion_video",
  cost_per_integrated_video: "play_circle_filled",
  cost_per_dedicated_video: "videocam",
  cost_per_short: "movie"
}
